import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-search-docs-api',
  templateUrl: './search-docs-api.component.html',
  styleUrls: ['./search-docs-api.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SearchDocsApiComponent implements OnInit {

  isDarkMode: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

  toggleTheme(): void {
    this.isDarkMode = !this.isDarkMode;
  }

  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      
      // Update active state in nav links
      document.querySelectorAll('.nav-link').forEach(l => l.classList.remove('active'));
      const activeLink = document.querySelector(`[href="#${sectionId}"]`);
      if (activeLink) activeLink.classList.add('active');
    }
  }

}
